import './TaskEdit.scss';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Alert, Breadcrumb, Button, Card, Col, Container, Form, Row, Modal, Badge, Tabs, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AppLoader from '../../components/AppLoader';
import { useFullScreenLoader } from '../../contexts/fullScreenLoader';
import { useToasts } from '../../contexts/toasts';
import { Task } from '../../models/Task';
import { cloneDeep, set } from 'lodash';
import IconButton from '../../components/IconButton';
import { useAuth } from '../../contexts/auth';
import { Tasks } from '../../api/Tasks';
import { TaskParameter, pType, SeedForRandom, generatedQuestions, enumerator, genType } from '../../models/TaskParameter';
import { Metric } from '../../models/Metric';
import TaskMetricsComponent from '../../components/TaskMetricsComponent';



export default function TaskEdit() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [task, setTask] = useState<Task>();
    const [param, setParam] = useState<TaskParameter>(new TaskParameter());
    const [editParam, setEditParam] = useState<number | null>(null);

    const [seed, setSeed] = useState<SeedForRandom>(new SeedForRandom())

    const [questionsList, setQuestionsList] = useState<generatedQuestions[]>([])
    const [question, setQuestion] = useState<generatedQuestions>(new generatedQuestions())
    const [editingQuestion, setEditingQuestion] = useState<number | null>(null)

    const [enumer, setEnumer] = useState<enumerator>(new enumerator())
    const [enumList, setEnumList] = useState<enumerator[]>([])
    const [editingEnum, setEditingEnum] = useState<number | null>(null)

    const [intListValue, setIntListValue] = useState<number>(0);
    const [intList, setIntList] = useState<number[]>([])
    const [editingInt, setEditingInt] = useState<number | null>(null)

    const [floatListValue, setFloatListValue] = useState<number>(0);
    const [floatList, setFloatList] = useState<number[]>([])
    const [editingFloat, setEditingFloat] = useState<number | null>(null)

    const [textListValue, setTextListValue] = useState<string>("");
    const [textList, setTextList] = useState<string[]>([])
    const [editingText, setEditingText] = useState<number | null>(null)

    const [metricList, setMetricList] = useState<Metric[]>([]);

    const { showLoader, hideLoader } = useFullScreenLoader();
    const { showToast } = useToasts();

    const [validated, setValidated] = useState<boolean>();


    const [editing, setEditing] = useState<number | undefined>();
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    const { token } = useAuth();

    useEffect(() => {
        if (id) initTask();
        else setTask(new Task());
    }, []);

    const initTask = () => {
        Tasks.getTask(id!)
            .then(
                ({ data: task }) => {
                    let normalizedTask = task;

                    const normalizedParams = normalizedTask.parameters.map((pm) => {
                        let normalizedQuestion;
                        if (pm.type === pType.GENERATEDQUESTIONS) {

                            normalizedQuestion = pm.content?.map((elem: any) => {
                                if (elem.correct_from_platform) {
                                    return { question: elem.question, noOfAnswers: 0, answers: [], correct: [], gen_type: "fixed" }
                                }

                                return { ...elem, correct: elem.correct?.join() || "" }

                            })
                            return { ...pm, content: normalizedQuestion };
                        }
                        return pm
                    })

                    normalizedTask.parameters = normalizedParams;
                    setTask(normalizedTask);
                },
                (err) => {
                    const message = err.response?.data?.message || err.message;
                    const status = err.response?.status;
                    showToast!('task-error', message, `Tasks Error ${status ? `(${status})` : ''}`, 'danger');
                }
            );
    }

    const cancel = () => navigate('/tasks');

    const openParamModal = () => setShowEditModal(true);
    const handleCreateModalClose = () => {
        setShowEditModal(false);
        setValidated(false);
        resetComplexParam()
        setParam(new TaskParameter());
    }

    const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {

        const form = evt.currentTarget;
        evt.stopPropagation();
        evt.preventDefault();
        setValidated(true);

        if (form.checkValidity() === true) {
            showLoader!();

            let currentTask = task!;
            currentTask.metricTypes = metricList.map((metricType: Metric) => metricType.id!);
            currentTask.parameters = currentTask.parameters.filter((tskParam) => tskParam.key !== 'task_name')

            const promise = id
                ? Tasks.updateTask(currentTask as Task)
                : Tasks.createTask(currentTask as Task);

            promise.then(
                ({ data: newTask }) => {
                    hideLoader!();
                    navigate("/tasks")
                },
                (err) => {
                    const message = err.response?.data?.message || err.message;
                    const status = err.response?.status;
                    hideLoader!();
                    showToast!('task-error', message, `Task Error ${status ? `(${status})` : ''}`, 'danger');
                }
            )
        }
    }


    const handleParamSubmit = () => {
        let status = validateParamForm()

        if (!status.valid) {
            showToast!('param-error', status.errors, `Param form error`, 'danger');
            return
        }

        let completedParam = { ...param };
        switch (completedParam.type) {
            case pType.GENERATEDQUESTIONS:
                console.log(questionsList)
                completedParam.content = questionsList.map((quest) => (
                    {
                        ...quest,
                        correct: Array.isArray(quest.correct) ? quest.correct : (quest.correct as String).split(',').map(t => t.trim()),
                        answers: Array.isArray(quest.answers) ? quest.answers : (quest.answers as String).split(',').map(t => t.trim())
                    })
                )
                break;
            case pType.SEEDFORRANDOM:
                completedParam.content = Object.fromEntries(
                    Object.entries(seed).map(([key, val]) => [key, Number(val)]),
                );
                break;
            case pType.ENUM:
                completedParam.content = enumList;
                break;
            case pType.LISTINTEGER:
                completedParam.content = intList.map((n) => Number(n))
                break;
            case pType.LISTFLOAT:
                completedParam.content = floatList.map((n) => Number(n));
                break;
            case pType.LISTTEXT:
                completedParam.content = textList;
                break;
        }

        let updateParamList = [...task!.parameters]

        if (editParam !== null) {
            updateParamList.splice(editParam, 1, completedParam);
            setEditParam(null)
        } else {
            updateParamList.push(completedParam);
        }

        console.log(updateParamList)

        setTask({ ...task!, parameters: [...updateParamList] })

        handleCreateModalClose();

    }

    function validateParamForm() {

        let status: { valid: boolean, errors: string[] } = { valid: true, errors: [] }

        console.log(param)
        if (param.type === pType.INTEGER) {
            if (String(param.defaultValue).includes(',') || String(param.defaultValue).includes('.')) {
                status.valid = false
                status.errors.push('Default value is not an integer\n')
            }
            if (param.min && String(param.min).includes(',') || String(param.min).includes('.')) {
                status.valid = false
                status.errors.push('Min value is not an integer\n')
            }
            if (param.max && String(param.max).includes(',') || String(param.max).includes('.')) {
                status.valid = false
                status.errors.push('Max value is not an integer\n')
            }
        }

        if (param.type === pType.INTEGER || param.type === pType.FLOAT) {

            if (param.min) {
                status.valid = Number(param.defaultValue) >= Number(param.min)
            }
            if (param.max) {
                status.valid = Number(param.defaultValue) <= Number(param.max)
            }
            if (param.min && param.max) {
                status.valid = Number(param.defaultValue) >= Number(param.min) && Number(param.defaultValue) <= Number(param.max)
            }
            if (status.valid === false) {
                status.errors.push('Default value does not respect the min and max limits\n')
            }

        }

        if (!param.defaultValue &&
            param.type !== pType.LISTINTEGER &&
            param.type !== pType.LISTFLOAT &&
            param.type !== pType.LISTTEXT &&
            param.type !== pType.SEEDFORRANDOM &&
            param.type !== pType.GENERATEDQUESTIONS) {
            status.valid = false
            status.errors.unshift("Missing Default Value\n")
        }

        if (!param.label) {
            status.valid = false
            status.errors.unshift("Missing Label\n")
        }
        if (!param.key) {
            status.valid = false
            status.errors.unshift("Missing Key\n")
        }

        return status
    }
    function resetComplexParam() {
        setQuestion(new generatedQuestions())
        setQuestionsList([])
        setEditingQuestion(null)
        setEnumer(new enumerator())
        setEnumList([])
        setEditingEnum(null)
        setSeed(new SeedForRandom())
        setIntList([])
        setEditingInt(null)
        setFloatList([])
        setEditingFloat(null)
        setTextList([])
        setEditingText(null)
    }

    function removeParam(pIndex: number) {

        let updateParamList = [...task!.parameters]
        updateParamList.splice(pIndex, 1);

        setTask({ ...task!, parameters: [...updateParamList] })

    }

    const handleFieldChange = (path: string) => (evt: React.ChangeEvent<any>) => {
        const value = evt.target.value;
        const newTask = cloneDeep(task) as Task;
        set(newTask, path, value);
        setTask(newTask);
    }

    const handleParameterChange = (key: string) => (evt: React.ChangeEvent<any>) => {

        const value = evt.target.value;
        setParam({
            ...param!,
            [key]: value
        })
    }

    const handleSeedChange = (key: string) => (evt: React.ChangeEvent<any>) => {
        const value = evt.target.value;
        setSeed({
            ...seed!,
            [key]: value
        })
    }

    const handleQuestionChange = (key: string) => (evt: React.ChangeEvent<any>) => {
        const value = evt.target.value;
        setQuestion({
            ...question!,
            [key]: value
        })
    }

    const handleEnumChange = (key: string) => (evt: React.ChangeEvent<any>) => {
        const value = evt.target.value;

        setEnumer({
            ...enumer!,
            [key]: value
        })
    }
    const handleListsValueChange = (type: 'int' | 'float' | 'string') => (evt: React.ChangeEvent<any>) => {
        const value = evt.target.value;
        const types = {
            'int': () => setIntListValue(value),
            'float': () => setFloatListValue(value),
            'string': () => setTextListValue(value),
        }

        types[type]();
    }

    const addQuestion = () => {
        if (editingQuestion !== null) {
            let updatedQuestionList = [...questionsList]
            updatedQuestionList.splice(editingQuestion, 1, question);
            setQuestionsList(updatedQuestionList)
            setEditingQuestion(null)
        } else {
            setQuestionsList((list) => [...list!, question])
        }
        setQuestion(new generatedQuestions())
    }

    const editQuestion = (question: generatedQuestions, index: number) => {
        setEditingQuestion(index)

        setQuestion({ ...question });
    }

    const removeQuestion = (qIndex: number) => {
        let newQuestionList = [...questionsList]
        newQuestionList.splice(qIndex, 1);
        setQuestionsList(newQuestionList)
    }

    const addEnum = () => {
        if (editingEnum !== null) {
            let updatedEnumList = [...enumList]
            updatedEnumList.splice(editingEnum, 1, enumer);
            setEnumList(updatedEnumList)
            setEditingQuestion(null)
        } else {
            setEnumList((list) => [...list!, enumer])
        }
        setEnumer(new enumerator())
    }

    const editEnum = (enumer: enumerator, index: number) => {
        setEditingEnum(index)
        setEnumer(enumer);
    }

    const removeEnum = (eIndex: number) => {
        let newEnumList = [...enumList]
        newEnumList.splice(eIndex, 1);
        setEnumList(newEnumList)
    }

    const addIntListValue = () => {
        if (editingInt !== null) {
            let updatedIntList = [...intList]
            updatedIntList.splice(editingInt, 1, intListValue);
            setIntList(updatedIntList)
            setEditingInt(null)
        } else {
            setIntList((list) => [...list!, intListValue])
        }
        setIntListValue(0)
    }
    const addFloatListvalue = () => {
        if (editingFloat !== null) {
            let updatedFloatList = [...floatList]
            updatedFloatList.splice(editingFloat, 1, floatListValue);
            setFloatList(updatedFloatList)
            setEditingFloat(null)
        } else {
            setFloatList((list) => [...list!, floatListValue])
        }
        setFloatListValue(0)
    }
    const addTextListvalue = () => {
        if (editingText !== null) {
            let updatedTextList = [...textList]
            updatedTextList.splice(editingText, 1, textListValue);
            setTextList(updatedTextList)
            setEditingText(null)
        } else {
            setTextList((list) => [...list!, textListValue])
        }
        setTextListValue("")
    }


    const editIntListValue = (value: number, index: number) => {
        setEditingInt(index)
        setIntListValue(value);
    }
    const editFloatListValue = (value: number, index: number) => {
        setEditingFloat(index)
        setFloatListValue(value);
    }
    const editTextListValue = (value: string, index: number) => {
        setEditingText(index)
        setTextListValue(value);
    }

    const removeIntListValue = (intIndex: number) => {
        let newIntList = [...intList]
        newIntList.splice(intIndex, 1);
        setIntList(newIntList)
    }
    const removeFloatListValue = (flIndex: number) => {
        let newFloatList = [...floatList]
        newFloatList.splice(flIndex, 1);
        setFloatList(newFloatList)
    }
    const removeTextListValue = (texIndex: number) => {
        let newTextList = [...textList]
        newTextList.splice(texIndex, 1);
        setTextList(newTextList)
    }

    const editTaskParam = (pIndex: number, tParam: TaskParameter) => {
        setEditParam(pIndex)
        prepareParam(tParam)

        openParamModal()
    }


    function prepareParam(tParam: TaskParameter) {

        console.log(tParam)
        switch (tParam.type) {
            case pType.GENERATEDQUESTIONS:
                setQuestionsList(tParam.content)
                break;
            case pType.SEEDFORRANDOM:
                setSeed(tParam.content)
                break;
            case pType.ENUM:
                setEnumList(tParam.content);
                break;
            case pType.LISTINTEGER:
                setIntList(tParam.content);
                break;
            case pType.LISTFLOAT:
                setFloatList(tParam.content);
                break;
            case pType.LISTTEXT:
                setTextList(tParam.content);
                break;

        }
        setParam({
            ...tParam!
        })
    }




    const renderTaskForm = () => {

        return (
            <>
                <div className="border-bottom py-2 px-3">
                    <Card.Title className="mb-0">{id ? task?.name : t('taskEdit.title')}</Card.Title>
                </div>

                <Form validated={validated} noValidate onSubmit={handleSubmit}>
                    <Card.Body>
                        <Row>
                            <Col>
                                <Form.Group controlId="task-name" className="mb-3">
                                    <Form.Label>{t('common.name')}</Form.Label>
                                    <Form.Control placeholder={t('taskEdit.taskName')} size="sm" value={task!.name} onChange={handleFieldChange('name')} required />
                                    <Form.Control.Feedback type="invalid">{t('errors.requiredField', { field: t('common.name') })}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="task-description" className="mb-3">
                                    <Form.Label>{t('common.description')}</Form.Label>
                                    <Form.Control as="textarea" rows={3} placeholder={t('taskEdit.taskDescription')} size="sm" value={task!.description} onChange={handleFieldChange('description')} />
                                </Form.Group>

                                <Form.Group controlId="task-videourl" className="mb-3">
                                    <Form.Label>{t('taskEdit.videourl')}</Form.Label>
                                    <Form.Control placeholder={t('taskEdit.videourl')} size="sm" value={task!.videoUrl} onChange={handleFieldChange('videoUrl')} />
                                </Form.Group>

                                <Form.Group controlId="task-type" className="mb-3">
                                    <Form.Label>{t('common.type')}</Form.Label>
                                    <Form.Control placeholder={t('taskEdit.type')} size="sm" value={task!.type} onChange={handleFieldChange('type')} />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Tabs
                            defaultActiveKey="parameters"
                            id="parametrictab"
                            className="mb-3"
                        >
                            <Tab eventKey="parameters" title="Parameters">
                                <Row className=''>
                                    <Col md={12} className='d-flex justify-content-end mb-2'>
                                        <Button variant="success" size="sm" onClick={openParamModal}>
                                            <FontAwesomeIcon icon={solid('plus')} />
                                            <span className='ms-2'>{t('taskEdit.addParameter')}</span>
                                        </Button>
                                    </Col>
                                </Row>
                                <Row className="px-2">
                                    <Col md={12} >
                                        {task!.parameters.length <= 0
                                            ?
                                            <Alert className=" text-center" variant="warning">
                                                <FontAwesomeIcon size="lg" icon={solid('exclamation-triangle')} />
                                                <span className="ms-2">{t('taskEdit.emptyParams')}</span>
                                            </Alert>
                                            :
                                            <Row>
                                                {task!.parameters.map((tparam, index) => {
                                                    if (tparam.key !== 'task_name') {
                                                        return (
                                                            <Col md={12} className="d-flex justify-content-between border p-2" key={`param-${index}`}>
                                                                <div>
                                                                    {tparam.label !== ""
                                                                        ? <span className='pe-3 align-self-center'>{tparam.label}</span>
                                                                        : <span className='pe-3 align-self-center'>{tparam.key}</span>
                                                                    }
                                                                    <Badge bg="primary" className="border align-self-center text-end">
                                                                        {tparam.key}
                                                                    </Badge>
                                                                    <Badge bg="light" className="ms-3 text-muted border align-self-center text-end">
                                                                        {tparam.type}
                                                                    </Badge>
                                                                </div>

                                                                <div  >
                                                                    <IconButton type="button" className="ms-2" onClick={() => editTaskParam(index, tparam)}>
                                                                        <FontAwesomeIcon icon={solid('pen')} />
                                                                    </IconButton>
                                                                    <IconButton className="ms-2" onClick={() => removeParam(index)}>
                                                                        <FontAwesomeIcon className="text-danger" icon={solid('trash')} />
                                                                    </IconButton>
                                                                </div>
                                                            </Col>
                                                        )
                                                    }
                                                    return <></>
                                                })}
                                            </Row>}
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="metrics" title="Metrics">
                                <Row>
                                    <Col md={12}>
                                        <Row>
                                            <Col md={6} className='d-flex justify-content-between mb-2'>
                                                <Form.Label>{t('metricsList.taskMetrics')}</Form.Label>

                                            </Col>
                                            <Col md={6}>
                                                <Form.Label>{t("metricsList.availableMetrics")}</Form.Label>
                                            </Col>
                                        </Row>
                                        <Col>
                                            <TaskMetricsComponent initialTask={task!} metricList={metricList} setMetriclist={setMetricList} />
                                        </Col>
                                    </Col>
                                </Row>
                            </Tab>
                        </Tabs>
                    </Card.Body>

                    <div className="d-flex justify-content-between border-top py-2 px-3">

                        <Button variant="light" className="border" size="sm" onClick={cancel}>{t('common.cancel')}</Button>
                        <Button variant="success" size="sm" type="submit">{t('common.confirm')}</Button>
                    </div>
                </Form >

                <Modal show={showEditModal} onHide={handleCreateModalClose} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{editing !== undefined ? t('common.edit') : t('common.create')} {t('common.parameter')}</Modal.Title>
                    </Modal.Header>

                    <Form>
                        <Modal.Body>
                            <Row>
                                <Form.Group controlId="param-label">
                                    <Form.Label>{t('taskParam.label')}</Form.Label>
                                    <Form.Control placeholder={t('taskParam.label')} size="sm" value={param.label} onChange={handleParameterChange('label')} required />
                                    <Form.Control.Feedback type="invalid">{t('errors.requiredField', { field: t('taskParam.label') })}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="param-key">
                                    <Form.Label>{t('taskParam.key')}</Form.Label>
                                    <Form.Control placeholder={t('taskParam.key')} size="sm" value={param.key} onChange={handleParameterChange('key')} />
                                </Form.Group>

                                <Form.Group controlId="param-description">
                                    <Form.Label>{t('taskParam.description')}</Form.Label>
                                    <Form.Control placeholder={t('taskParam.description')} size="sm" value={param.description} onChange={handleParameterChange('description')} />
                                </Form.Group>

                                <Form.Group controlId="param-type">
                                    <Form.Label>{t('taskParam.type')}</Form.Label>
                                    <Form.Select size="sm" value={param.type} onChange={handleParameterChange('type')} required>
                                        <option value="" hidden disabled>{t('taskParam.selectType')}</option>
                                        {Object.values(pType)
                                            ?.map((type, index) => (
                                                <option key={index} value={type}>{type}</option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                                <hr className="my-3 divider mx-auto"></hr>
                                {renderParamFields()}

                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" className="border" size="sm" onClick={handleCreateModalClose}>{t('common.cancel')}</Button>

                            <Button variant="success" size="sm" onClick={handleParamSubmit}> {t('common.confirm')}</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </>
        )
    }

    function renderParamFields() {

        switch (param.type) {
            case pType.INTEGER:
                return (<>
                    <Form.Group controlId="param-unit">
                        <Form.Label>{t('taskParam.unit')}</Form.Label>
                        <Form.Control type="text" placeholder={t('taskParam.unit')} size="sm" value={param.unit} onChange={handleParameterChange('unit')} required />
                    </Form.Group>
                    <Form.Group controlId="param-defVal">
                        <Form.Label>{t('taskParam.defVal')}</Form.Label>
                        <Form.Control type="number" placeholder={t('taskParam.defVal')} size="sm" value={param.defaultValue} onChange={handleParameterChange('defaultValue')} />
                        <Form.Control.Feedback type="invalid">{t('errors.requiredField', { field: t('taskParam.label') })}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="param-min">
                        <Form.Label>{t('taskParam.min')}</Form.Label>
                        <Form.Control type="number" pattern="-?[0-9]+" placeholder={t('taskParam.min')} size="sm" value={param.min} onChange={handleParameterChange('min')} />
                    </Form.Group>
                    <Form.Group controlId="param-max">
                        <Form.Label>{t('taskParam.max')}</Form.Label>
                        <Form.Control type="number" pattern="-?[0-9]+" placeholder={t('taskParam.max')} size="sm" value={param.max} onChange={handleParameterChange('max')} />
                    </Form.Group>
                </>);
            case pType.FLOAT:
                return (<>
                    <Form.Group controlId="param-unit">
                        <Form.Label>{t('taskParam.unit')}</Form.Label>
                        <Form.Control type="text" placeholder={t('taskParam.unit')} size="sm" value={param.unit} onChange={handleParameterChange('unit')} />
                    </Form.Group>
                    <Form.Group controlId="param-defVal">
                        <Form.Label>{t('taskParam.defVal')}</Form.Label>
                        <Form.Control type="number" pattern="-?[0-9]+[.]?[0-9]+" placeholder={t('taskParam.defVal')} size="sm" value={param.defaultValue} onChange={handleParameterChange('defaultValue')} />
                    </Form.Group>
                    <Form.Group controlId="param-min">
                        <Form.Label>{t('taskParam.min')}</Form.Label>
                        <Form.Control type="number" pattern="-?[0-9]+[.]?[0-9]+" placeholder={t('taskParam.min')} size="sm" value={param.min} onChange={handleParameterChange('min')} />
                    </Form.Group>
                    <Form.Group controlId="param-max">
                        <Form.Label>{t('taskParam.max')}</Form.Label>
                        <Form.Control type="number" pattern="-?[0-9]+[.]?[0-9]+" placeholder={t('taskParam.max')} size="sm" value={param.max} onChange={handleParameterChange('max')} />
                    </Form.Group>
                </>)
            case pType.BOOLEAN:
                return (<>
                    <Form.Group controlId="param-defVal">
                        <Form.Label>{t('taskParam.defVal')}</Form.Label>
                        <Form.Select size="sm" value={param.defaultValue} onChange={handleParameterChange('defaultValue')} required>
                            <option value="true" >True</option>
                            <option value="false" >False</option>
                        </Form.Select>
                    </Form.Group>
                </>)
            case pType.TEXT:
                return (<>
                    <Form.Group controlId="param-unit">
                        <Form.Label>{t('taskParam.unit')}</Form.Label>
                        <Form.Control type="text" placeholder={t('taskParam.unit')} size="sm" value={param.unit} onChange={handleParameterChange('unit')} />
                    </Form.Group>
                    <Form.Group controlId="param-defVal">
                        <Form.Label>{t('taskParam.defVal')}</Form.Label>
                        <Form.Control type="text" placeholder={t('taskParam.defVal')} size="sm" value={param.defaultValue} onChange={handleParameterChange('defaultValue')} />
                    </Form.Group>
                </>)
            case pType.SEEDFORRANDOM:
                return (<Row>
                    <Col>
                        <Form.Group controlId="param-s0">
                            <Form.Label>Seed 0</Form.Label>
                            <Form.Control type="number" pattern="-?[0-9]+" placeholder={t('taskParam.s0')} size="sm" value={seed.s0} onChange={handleSeedChange('s0')} />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="param-s1">
                            <Form.Label>Seed 1</Form.Label>
                            <Form.Control type="number" pattern="-?[0-9]+" placeholder={t('taskParam.s1')} size="sm" value={seed.s1} onChange={handleSeedChange('s1')} />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="param-s2">
                            <Form.Label>Seed 2</Form.Label>
                            <Form.Control type="number" pattern="-?[0-9]+" placeholder={t('taskParam.s2')} size="sm" value={seed.s2} onChange={handleSeedChange('s2')} />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="param-s3">
                            <Form.Label>Seed 3</Form.Label>
                            <Form.Control type="number" pattern="-?[0-9]+" placeholder={t('taskParam.s3')} size="sm" value={seed.s3} onChange={handleSeedChange('s3')} />
                        </Form.Group>
                    </Col>
                </Row>)
            case pType.GENERATEDQUESTIONS:
                return (
                    <>
                        <Col md={12}>
                            <Row>
                                <Col>
                                    <Form.Group controlId="question" className="mb-1">
                                        <Form.Label>{t('taskParam.question')}</Form.Label>
                                        <Form.Control type="text" placeholder={t('taskParam.question')} size="sm" value={question.question} onChange={handleQuestionChange('question')} />
                                    </Form.Group>

                                    <Form.Group controlId="question-type">
                                        <Form.Label>{t('taskParam.type')}</Form.Label>
                                        <Form.Select size="sm" value={question.gen_type} onChange={handleQuestionChange('gen_type')} required>
                                            <option value="" hidden disabled>{t('taskParam.selectType')}</option>
                                            {Object.values(genType)
                                                ?.map((type, index) => (
                                                    <option key={index} value={type}>{type}</option>
                                                ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="param-noOfAnswers">
                                        <Form.Label>{t('taskParam.noOfAnswers')}</Form.Label>
                                        <Form.Control type="number" pattern="-?[0-9]+" placeholder={t('taskParam.noOfAnswers')} size="sm" value={question.noOfAnswers} onChange={handleQuestionChange('noOfAnswers')} />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={12}>
                            <Form.Group controlId="question-answers">
                                <Form.Label>{t('taskParam.answers')} (comma separated list)</Form.Label>
                                <Form.Control type="text" as="textarea" rows={4} placeholder={t('taskParam.answers')} size="sm" value={question.answers} onChange={handleQuestionChange('answers')} />
                            </Form.Group>

                            <Form.Group controlId="question-correct">
                                <Form.Label>{t('taskParam.correctFromPlatform')} (comma separated list)</Form.Label>
                                <Form.Control type="text" as="textarea" rows={4} placeholder={t('taskParam.correctFromPlatform')} size="sm" value={question.correct} onChange={handleQuestionChange('correct')} />
                            </Form.Group>
                        </Col>


                        <Col md={12} className='d-flex justify-content-end mt-2'>
                            <Button variant="success" className="border" size="sm" onClick={addQuestion}>{t('taskParam.addQuestion')} <FontAwesomeIcon icon={solid('plus')} /></Button>
                        </Col>

                        <Col md={12} className="mt-2">
                            {questionsList.length > 0 ? questionsList?.map((q, index) => {
                                return (
                                    <Col className="d-flex align-items-center justify-content-between border px-1" key={`q-${index}`}>
                                        <span>{q.question}</span>
                                        <div>
                                            <IconButton type='button' onClick={() => editQuestion(q, index)} >
                                                <FontAwesomeIcon icon={solid('pen')} />
                                            </IconButton>
                                            <IconButton type='button' className="text-danger" onClick={() => removeQuestion(index)}>
                                                <FontAwesomeIcon icon={solid('trash')} />
                                            </IconButton>
                                        </div>
                                    </Col>
                                )
                            }) : <Alert className="text-center mb-0" variant="warning">
                                <FontAwesomeIcon size="lg" icon={solid('exclamation-triangle')} />
                                <span className="ms-2">{t('taskEdit.emptyQuestion')}</span>
                            </Alert>}
                        </Col>

                    </>

                )
            case pType.ENUM:
                return (<>

                    <Col md={6}>
                        <Form.Group controlId="enum-key" className="mb-1">
                            <Form.Label>{t('taskParam.enumKey')}</Form.Label>
                            <Form.Control type="text" placeholder={t('taskParam.enumKey')} size="sm" value={enumer.key} onChange={handleEnumChange('key')} />
                        </Form.Group>

                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="enum-value">
                            <Form.Label>{t('taskParam.enumValue')}</Form.Label>
                            <Form.Control type="text" placeholder={t('taskParam.enumValue')} size="sm" value={enumer.value} onChange={handleEnumChange('value')} />
                        </Form.Group>
                    </Col>


                    <Col md={12} className='justify-content-center mt-2'>
                        <IconButton type='button' className="question-add" onClick={addEnum} >
                            <FontAwesomeIcon icon={solid('plus')} />
                        </IconButton>
                    </Col>

                    {enumList.length ?
                        <Col md={12}>
                            <Form.Group controlId="param-defValue-enum">
                                <Form.Label>{t('taskParam.defaultValue')}</Form.Label>
                                <Form.Select size="sm" value={param.defaultValue} onChange={handleParameterChange('defaultValue')} required>
                                    <option value="" hidden disabled>{t('taskParam.selectDefaultEnum')}</option>
                                    {enumList.map((enumer, index) => (
                                        <option key={index} value={enumer.key}>{enumer.key}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col> : <></>}

                    <Col md={12} className="mt-2">
                        {enumList?.map((e, index) => {
                            return (
                                <Col className="d-flex align-items-center justify-content-between border px-1" key={`e-${index}`}>
                                    <span>{`${e.key}: ${e.value}`}</span>
                                    <div>
                                        <IconButton type='button' onClick={() => editEnum(e, index)} >
                                            <FontAwesomeIcon icon={solid('pen')} />
                                        </IconButton>
                                        <IconButton type='button' className="text-danger" onClick={() => removeEnum(index)}>
                                            <FontAwesomeIcon icon={solid('trash')} />
                                        </IconButton>
                                    </div>
                                </Col>
                            )
                        })}
                    </Col>
                </>)
            case pType.LISTINTEGER:
                return (<>
                    <Form.Group controlId="param-unit">
                        <Form.Label>{t('taskParam.unit')}</Form.Label>
                        <Form.Control type="text" placeholder={t('taskParam.unit')} size="sm" value={param.unit} onChange={handleParameterChange('unit')} />
                    </Form.Group>
                    <Form.Group controlId="param-intList">
                        <Form.Label>{t('taskParam.intList')}</Form.Label>
                        <Form.Control type="number" placeholder={t('taskParam.intList')} size="sm" value={intListValue} onChange={handleListsValueChange('int')} />
                    </Form.Group>

                    <Col md={12} className='d-flex justify-content-end mt-2'>
                        <Button variant="success" className="border" size="sm" onClick={addIntListValue}>{t('taskParam.addIntValue')} <FontAwesomeIcon icon={solid('plus')} /></Button>
                    </Col>

                    <Col md={12} className="mt-2">
                        {intList.length ?
                            intList?.map((e, index) => {
                                return (
                                    <Col className="d-flex align-items-center justify-content-between border px-1" key={`e-${index}`}>
                                        <span>{e}</span>
                                        <div>
                                            <IconButton type='button' onClick={() => editIntListValue(e, index)} >
                                                <FontAwesomeIcon icon={solid('pen')} />
                                            </IconButton>
                                            <IconButton type='button' className="text-danger" onClick={() => removeIntListValue(index)}>
                                                <FontAwesomeIcon icon={solid('trash')} />
                                            </IconButton>
                                        </div>
                                    </Col>
                                )
                            }) : <Alert className="text-center mb-0" variant="warning">
                                <FontAwesomeIcon size="lg" icon={solid('exclamation-triangle')} />
                                <span className="ms-2">{t('taskParam.emptyIntList')}</span>
                            </Alert>}
                    </Col>
                </>);
            case pType.LISTFLOAT:
                return (<>
                    <Form.Group controlId="param-unit">
                        <Form.Label>{t('taskParam.unit')}</Form.Label>
                        <Form.Control type="text" placeholder={t('taskParam.unit')} size="sm" value={param.unit} onChange={handleParameterChange('unit')} />
                    </Form.Group>
                    <Form.Group controlId="param-floatList">
                        <Form.Label>{t('taskParam.floatList')}</Form.Label>
                        <Form.Control type="number" placeholder={t('taskParam.floatList')} size="sm" value={floatListValue} onChange={handleListsValueChange('float')} />
                    </Form.Group>

                    <Col md={12} className='d-flex justify-content-end mt-2'>
                        <Button variant="success" className="border" size="sm" onClick={addFloatListvalue}>{t('taskParam.addFloatValue')} <FontAwesomeIcon icon={solid('plus')} /></Button>
                    </Col>

                    <Col md={12} className="mt-2">
                        {floatList.length ? floatList?.map((e, index) => {
                            return (
                                <Col className="d-flex align-items-center justify-content-between border px-1" key={`e-${index}`}>
                                    <span>{e}</span>
                                    <div>
                                        <IconButton type='button' onClick={() => editFloatListValue(e, index)} >
                                            <FontAwesomeIcon icon={solid('pen')} />
                                        </IconButton>
                                        <IconButton type='button' className="text-danger" onClick={() => removeFloatListValue(index)}>
                                            <FontAwesomeIcon icon={solid('trash')} />
                                        </IconButton>
                                    </div>
                                </Col>
                            )
                        }) : <Alert className="text-center mb-0" variant="warning">
                            <FontAwesomeIcon size="lg" icon={solid('exclamation-triangle')} />
                            <span className="ms-2">{t('taskParam.emptyFloatList')}</span>
                        </Alert>}
                    </Col>
                </>);
            case pType.LISTTEXT:
                return (<>
                    <Form.Group controlId="param-unit">
                        <Form.Label>{t('taskParam.unit')}</Form.Label>
                        <Form.Control type="text" placeholder={t('taskParam.unit')} size="sm" value={param.unit} onChange={handleParameterChange('unit')} />
                    </Form.Group>
                    <Form.Group controlId="param-floatList">
                        <Form.Label>{t('taskParam.textList')}</Form.Label>
                        <Form.Control type="text" placeholder={t('taskParam.textList')} size="sm" value={textListValue} onChange={handleListsValueChange('string')} />
                    </Form.Group>

                    <Col md={12} className='d-flex justify-content-end mt-2'>
                        <Button variant="success" className="border" size="sm" onClick={addTextListvalue}>{t('taskParam.addTextValue')} <FontAwesomeIcon icon={solid('plus')} /></Button>
                    </Col>

                    <Col md={12} className="mt-2">
                        {textList.length ? textList?.map((e, index) => {
                            return (
                                <Col className="d-flex align-items-center justify-content-between border px-1" key={`e-${index}`}>
                                    <span>{e}</span>
                                    <div>
                                        <IconButton type='button' onClick={() => editTextListValue(e, index)} >
                                            <FontAwesomeIcon icon={solid('pen')} />
                                        </IconButton>
                                        <IconButton type='button' className="text-danger" onClick={() => removeTextListValue(index)}>
                                            <FontAwesomeIcon icon={solid('trash')} />
                                        </IconButton>
                                    </div>
                                </Col>
                            )
                        }) : <Alert className="text-center mb-0" variant="warning">
                            <FontAwesomeIcon size="lg" icon={solid('exclamation-triangle')} />
                            <span className="ms-2">{t('taskParam.emptyTextList')}</span>
                        </Alert>}
                    </Col>
                </>);
            default:
                return (<></>)
        }


    }

    const logs = () => {
        console.log(task)
    }
    const renderAsyncContent = () => {
        if (id && !task) return (
            <div className="d-flex justify-content-center py-3">
                <AppLoader size={150} />
            </div>
        )

        return task && renderTaskForm();
    }

    return (
        <Container>
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/tasks' }}>{t('pages.tasks')}</Breadcrumb.Item>
                <Breadcrumb.Item active>{id ? task?.name : t('taskEdit.currentPage')}</Breadcrumb.Item>
            </Breadcrumb>

            <Card>{renderAsyncContent()}</Card>
        </Container>
    )
}